import type { ShipmentColumn } from '../../types/column-types'
import { renderShipment } from '../../helpers/helpers'

export const additionalJobsColumn: ShipmentColumn = {
    key: 'additional_jobs',
    dataIndex: ['additional_jobs'],
    title: 'Доп. работы',
    width: 80,
    render: (v, r) => r?.additional_jobs?.map(x => x.name).join(', ') || '',
}
